import type { IntegrationServices } from '@/modules/common/types/integrations';

export enum InvoiceStatus {
  Open = 'open',
  Paid = 'paid',
  Overdue = 'overdue',
  InProgress = 'in-progress',
  Error = 'error',
  Unknown = 'unknown',
}

export interface InvoiceProjectInfo {
  id: number;
  name: string;
  status: string | null;
  colorHex: string | null;
  logoUrl: string | null;
}

export interface InvoiceClientInfo {
  id: number;
  name: string;
  logoUrl: string | null;
}

export enum InvoiceSyncOperation {
  Create = 'CREATE',
  Update = 'UPDATE',
}

export enum InvoiceSyncErrorReason {
  ProjectNotAvailable = 'PROJECT_NOT_AVAILABLE',
  CustomerNotAvailable = 'CUSTOMER_NOT_AVAILABLE',
  ProductOrServiceNotAvailable = 'PRODUCT_OR_SERVICE_NOT_AVAILABLE',
  CustomerCurrencyMismatch = 'CUSTOMER_CURRENCY_MISMATCH',
  CurrencyNotEnabled = 'CURRENCY_NOT_ENABLED',
  AccountingPeriodClosed = 'ACCOUNTING_PERIOD_CLOSED',
  NegativeLineAmountNotAllowed = 'NEGATIVE_LINE_AMOUNT_NOT_ALLOWED',
  LineDescriptionTooLong = 'LINE_DESCRIPTION_TOO_LONG',
  PaymentTermNotAvailable = 'PAYMENT_TERM_NOT_AVAILABLE',
  TransactionDateNotAllowed = 'TRANSACTION_DATE_NOT_ALLOWED',
  LineValueOutOfRange = 'LINE_VALUE_OUT_OF_RANGE',
  DataRejected = 'DATA_REJECTED',
}

export interface InvoiceSyncError {
  code: number;
  message: string;
  provider: IntegrationServices | null;
  details: string[] | null;
  reason: InvoiceSyncErrorReason | null;
}

export interface InvoiceListItem {
  id: number;
  /** Unique invoice number from QuickBooks */
  number: string | null;
  externalId: string | null;
  project: InvoiceProjectInfo | null;
  client: InvoiceClientInfo;
  status: InvoiceStatus;
  issuedDate: Date;
  dueDate: Date;
  /** Formatted billing period (e.g., "Jan 1 - Jan 31, 2025") */
  period: string;
  balance: string;
  amount: string;
  currencyCode: string;
  syncOperation: InvoiceSyncOperation | null;
  syncError: InvoiceSyncError | null;
}
